/* eslint-disable max-len */
import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide';

import mediaQueries from '../../utils/media-query/media-query-constants';
import useMediaQuery from '../../utils/media-query/media-query-hook';
import classes from './gallery-block.module.scss';
import { GalleryBlockProps } from './GalleryBlock.type';

function GalleryBlock({ images, title }: GalleryBlockProps) {
  const isMobile = useMediaQuery(mediaQueries.mobile);

  return (
    <div className={classes.container}>
      {title && (
        <div className={classes.header}>
          <h2>{title}</h2>
        </div>
      )}

      <div className={classes.cardsContainer}>
        <Splide
          hasTrack={false}
          options={{
            gap: '20px',
            type: 'slide',
            drag: true,
            arrows: false,
            width: '100%',
            fixedHeight: isMobile ? '420px' : '650px',
            pagination: true,
            perMove: 1,
            omitEnd: true,
          }}
          className={classes.slider}
        >
          <SplideTrack>
            {images.map((item) => (
              <SplideSlide key={item.id}>
                <div
                  className={classes.card}
                  style={{
                    background: isMobile
                      ? `linear-gradient(180deg, #1D1D1D -22.26%, rgba(29, 29, 29, 0.00) 17.45%), linear-gradient(0deg, #1D1D1D 8.19%, rgba(29, 29, 29, 0.00) 51.05%), url(${item.image}) lightgray 50% / cover no-repeat`
                      : `linear-gradient(0deg, #1D1D1D -7.15%, rgba(29, 29, 29, 0.00) 34.4%), linear-gradient(180deg, rgba(0, 0, 0, 0.00) 69.92%, rgba(0, 0, 0, 0.70) 100.03%), url(${item.image}) 50% / cover no-repeat`,
                  }}
                >
                  <div className={classes.content}>
                    <p className={classes.subtitle}>{item.text}</p>
                    <p className={classes.title}>{item.title}</p>
                  </div>
                </div>
              </SplideSlide>
            ))}
          </SplideTrack>
        </Splide>
      </div>
    </div>
  );
}

export default GalleryBlock;
